import React, { useState } from "react";
import { AdminLayout } from "@opendash/core";
import { ParseSetView } from "@opendash/plugin-parse";
import { TableViewType } from "@opendash/plugin-parse/dist/types";
import { Segmented } from "antd";

const KauflandClass = "HG_Kaufland";
const LidlClass = "HG_Lidl";

export default function KauflandMeta() {
  const [active, setActive] = useState<"kaufland" | "lidl">("kaufland");

  const tabLabel = (key: "kaufland" | "lidl", text: string) => (
    <span
      style={{
        display: "block",
        padding: "8px 0",
        borderRadius: 6,
        color: active === key ? "#fff" : "#555",
        backgroundColor: active === key ? "#fec000" : "transparent",
        fontWeight: active === key ? 700 : 500,
      }}
    >
      {text}
    </span>
  );

  return (
    <AdminLayout>
      <Segmented
        block
        size="large"
        value={active}
        onChange={(value) => setActive(value as "kaufland" | "lidl")}
        style={{
          fontSize: 20,
          fontWeight: 600,
          padding: 6,
          marginBottom: 16,
          backgroundColor: "#fff",
        }}
        options={[
          { label: tabLabel("kaufland", "Kaufland"), value: "kaufland" },
          { label: tabLabel("lidl", "Lidl"), value: "lidl" },
        ]}
      />

      {active === "kaufland" ? (
        <ParseSetView
          className={KauflandClass}
          view={
            {
              type: "table",
              fields: ["machine", "store_no", "order_code"],
            } as TableViewType
          }
        />
      ) : (
        <ParseSetView
          className={LidlClass}
          view={
            {
              type: "table",
              fields: ["machine", "store_no", "lidl_company_no", "machine_secret"],
            } as TableViewType
          }
        />
      )}
    </AdminLayout>
  );
}
